// Module
var code = "<ui-view> <financial-accounts-report></financial-accounts-report> </ui-view> ";
// Exports
module.exports = code;